import { BroadcastQuality } from '@core/types';

export interface BroadcastQualityPreset {
    width: number;
    height: number;
    /** Video encoder target bitrate in bits per second. */
    videoBitrate: number;
    /** Audio encoder target bitrate in bits per second. */
    audioBitrate: number;
}

/**
 * Single source of truth for what each quality tier means on both broadcast paths.
 * `Record<BroadcastQuality, ...>` makes the compiler enforce that every tier has a preset.
 */
export const BROADCAST_QUALITY_PRESETS: Record<BroadcastQuality, BroadcastQualityPreset> = {
    [BroadcastQuality.High]: { width: 1280, height: 720, videoBitrate: 4_000_000, audioBitrate: 256_000 },
    [BroadcastQuality.Medium]: { width: 1280, height: 720, videoBitrate: 2_000_000, audioBitrate: 128_000 },
    [BroadcastQuality.Low]: { width: 854, height: 480, videoBitrate: 1_000_000, audioBitrate: 64_000 }
};
